<template>
  <div>
<!--    <div class="form-group" v-if="this.state.registrantData.freeRegEligibiltyRequired && this.state.registrantData.promoData.Code.state === 'pass'">
      <h4>Free Registration Eligibility:</h4>
      <p>
        This complimentary registration is offered only to Schweiger Dermatology Group providers. SDG providers will be
        required to sign in and attend both days of the meeting on November 16 and November 17. If the attendee does not
        attend and sign in each day, a registration fee of $100 will be charged after the meeting.
      </p>
      <label for="reg_eligibilty"> I understand and acknowledge this requirement. </label>
      <input class="" type="checkbox" name="reg_eligibilty" v-model="state.formstate.reg_eligibilty"
             id="reg_eligibilty" style="margin-left: 5px">

    </div>-->
    <br>
    <div>
      <h4>Terms and Conditions</h4>
      <hr>
      <div class="policyarea">
        <div>
<!--          <p><strong>COVID-19 Policy</strong><br>-->
<!--            I agree to adhere to all infectious disease protocols in place during the event, including those-->
<!--            imposed by NFCM, the venue, the county health department, and any state directives, and if I so-->
<!--            fail, I hereby consent to be ejected from the symposium and the venue with no refund.-->
<!--          </p>-->
<!--          <p><strong>Assumption of Risk</strong><br>-->
<!--            I accept and assume all risks of my in-person participation, including the risk of injury or-->
<!--            contracting an infectious disease, including but not limited to COVID-19 exposure.-->
<!--          </p>-->
          <p><strong>Badge Information</strong><br>
            By registering for the New Frontiers in Cosmetic Medicine and Medical Dermatology (NFCMMD)
            Symposium, the attendee understands and agrees that attendee's name, contact information, city,
            and state may be shared with other attendees and exhibitors through attendee lists and/or lead
            retrieval systems.
          </p>
          <p><strong>Code of Conduct</strong><br>
            It is expected that all meeting attendees to maintain high standards of professional conduct and
            uphold the policies and procedures set forth for the meeting. To the degree that an attendee,
            individually or collectively, purposefully and fraudulently circumvents the NFCMMD rules,
            regulations and ethical standards, the NFCMMD vies such conduct as serious violation that will
            jeopardize attendance at the meeting and could jeopardize attendance at future NFCMMD meetings.
            The NFCMMD prohibits harassment by a client, an attendee, vendor, or others who may interact
            with staff during their course of business. The NFCMMD reserves the right to refuse entry or
            revoke the registration of any individual, without refund, if such refusal is consistent with
            NFCMMD policy.
          </p>
          <p><strong>Cancellation Policy</strong><br>
            NFCM will offer a 100% refund within 72 hours from time of purchase. After 72 hours refunds will be less
            50%. All refunds must be made in writing via email or post marked/tax stamped no later than 30 days before
            the event. No refund will be made if the request is made within 30 days of the educational event. Refunds
            will not be issued to non-show registrants. Substitutions are always welcome, with the payment of a
            processing fee of $50.
          </p>
          <p><strong>Special Needs</strong><br>
            We encourage participation by all individuals. If you have a disability, advance notification of
            any special needs will help us better serve you. Please contact the office at 904-998-0853 or by
            email to info@cosmeticfrontiers.com at least six (6) weeks in advance prior to the event.
          </p>
          <p><strong>Communication, Confirmation and Receipts</strong><br>
            You must provide a valid email address when you register online to receive a Symposium
            confirmation/receipt. Communications regarding Symposium updates will only be made via email.
            Please remember to check your spam/junk box for confirmation emails and receipts.
          </p>
          <p><strong>Consent</strong><br>
            You consent to the photographing and recording of your likeness and voice and the use of these
            photographs and/or recordings singularly or in conjunction with other photographs and/or
            recordings for advertising, publicity, commercial or other business purposes. You understand
            that the term “photograph” encompasses both still photographs and motion picture footage. You
            further consent to the reproduction and/or authorization by the NFCMMD to reproduce and use said
            photographs and recordings, for use in all domestic and foreign markets. You hereby release
            NFCMMD and any of its associated or affiliated companies, their directors, officers, agents,
            employees and customers, and appointed advertising agencies, their directors, officers, agents
            and employees from all claims of every kind on account of such use. You agree that the NFCMMD
            shall be the sole owner of all material captured at NFCMMD and reproduced for post-event
            products.¬
          </p>
          <p><strong>Rules and Regulations: Session Photography and/or Video Recording</strong><br>
            Photography and/or video recording of any kind are strictly prohibited in the sessions. Violators of this
            policy are subject to ejection from the Symposium and refunds will not be issued.
          </p>
          <p><strong>Special Considerations</strong><br>
            While every attempt will be made to control the temperature in the meeting room for your comfort, please
            remember to bring a jacket or sweater. Please note that, unfortunately, we do not accept any special meal
            requests. If you have specific dietary concerns, you will be responsible for arranging alternatives at your
            own cost.
          </p>
          <p><strong>Meals</strong><br>
            The Symposium fee includes breakfast, lunch and coffee breaks for the participant only. There may be meals
            provided by pharmaceutical or other industry members as part of the non-CME educational programs. It is the
            responsibility of the participant to know their state laws and employer regulations regarding acceptance of
            meals and gifts. Conference registrants should not register to participate in the meals if they are barred
            from accepting meals and gifts (inclusive of certain thresholds) provided by the pharmaceutical and/or other
            industry by their employer and/or state licensing board. NFCM cannot provide separate meals for participants
            who do not register to attend non-CME educational programs, and participants will need to make their own
            meal arrangements.
          </p>
        </div>
      </div>
      <br>
      <div class="form-group">
        <label for="terms"><em>I agree to the above terms &amp; conditions</em></label>
        <input class="" type="checkbox" name="terms" v-model="state.formstate.terms"
               id="terms" style="margin-left: 10px">
        <hr>
        <label><em>Please enter your name below to verify that you agree to the terms and conditions. By
          entering your name here, you are consenting to the use of your electronic signature in lieu of an
          original signature on paper.</em></label>
        <input type="text" class="form-control" v-model="state.formstate.signature">
      </div>
    </div>
    <br>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: "Terms",
  computed: {
    ...mapGetters({
      state: 'getState'
    }),
  },
}
</script>

<style>
.policyarea {
  height: 300px;
  overflow-y: scroll;
}
</style>